import * as React from 'react';
import RouteAdmin from '../router/RouteAdmin';

import AdminPage from './AdminPage';
import RoutePrivate from '../router/RoutePrivate';
import UserDetails from 'src/models/UserDetails';
import Permissions from 'src/models/Permissions';
import Authorization from 'src/util/Authorization';
import { UserRoles } from 'src/models/UserRole';

export default function getRoutes(isLoggedIn: boolean, user: UserDetails) {
    const isAdmin =
        Authorization.IsInRole(UserRoles.Admin, user) || Authorization.HasRole('Admin', user);

    return [
        <RoutePrivate
            key="role-management"
            path="/admin/roles"
            component={AdminPage}
            isLoggedIn={isLoggedIn}
            user={user}
            permissions={[Permissions.RolesManage, Permissions.UserRolesManage]}
        />,
        <RouteAdmin key="admin" path="/admin" component={AdminPage} isLoggedIn={isLoggedIn} isAdmin={isAdmin} />,
    ];
}



// WEBPACK FOOTER //
// ./src/components/admin/Admin.Routes.tsx